<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
  <p>
    <mat-form-field appearance="outline">
        <mat-label>Batch number</mat-label>
        <input required [formControl]="batchNumber" matInput>
      </mat-form-field>
  </p>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">No</button>
  <button [disabled]="!batchNumber.valid" mat-raised-button [mat-dialog-close]="{confirm: true, batch_number: batchNumber.value }" color="primary" cdkFocusInitial>Yes</button>
</div>
